module.exports = __webpack_public_path__ + "e3384fefd15277b82edcbf359cbcd3c4.svg";